export const sortUsersByName = (users) => [...(users || [])].sort((first, second) => (
  (first?.name || "").trim().localeCompare((second?.name || "").trim(), "en-GB", { sensitivity: "base" })
));
